const middlewares = []

if (__CLIENT__) {
  middlewares.push(require('./middlewares/sessionStorage').default)
}

export default middlewares
